/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetQuestionAndAnswerDto } from './GetQuestionAndAnswerDto';
import {
    GetQuestionAndAnswerDtoFromJSON,
    GetQuestionAndAnswerDtoFromJSONTyped,
    GetQuestionAndAnswerDtoToJSON,
} from './GetQuestionAndAnswerDto';

/**
 * 
 * @export
 * @interface GetSurveyAnswersByClientSurveyIdDto
 */
export interface GetSurveyAnswersByClientSurveyIdDto {
    /**
     * 
     * @type {string}
     * @memberof GetSurveyAnswersByClientSurveyIdDto
     */
    clientSurveyId: string;
    /**
     * 
     * @type {string}
     * @memberof GetSurveyAnswersByClientSurveyIdDto
     */
    clientName: string;
    /**
     * 
     * @type {string}
     * @memberof GetSurveyAnswersByClientSurveyIdDto
     */
    surveyNamePl: string;
    /**
     * 
     * @type {string}
     * @memberof GetSurveyAnswersByClientSurveyIdDto
     */
    surveyNameEn: string;
    /**
     * 
     * @type {Array<GetQuestionAndAnswerDto>}
     * @memberof GetSurveyAnswersByClientSurveyIdDto
     */
    questionsWithAnswers: Array<GetQuestionAndAnswerDto>;
}

/**
 * Check if a given object implements the GetSurveyAnswersByClientSurveyIdDto interface.
 */
export function instanceOfGetSurveyAnswersByClientSurveyIdDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clientSurveyId" in value;
    isInstance = isInstance && "clientName" in value;
    isInstance = isInstance && "surveyNamePl" in value;
    isInstance = isInstance && "surveyNameEn" in value;
    isInstance = isInstance && "questionsWithAnswers" in value;

    return isInstance;
}

export function GetSurveyAnswersByClientSurveyIdDtoFromJSON(json: any): GetSurveyAnswersByClientSurveyIdDto {
    return GetSurveyAnswersByClientSurveyIdDtoFromJSONTyped(json, false);
}

export function GetSurveyAnswersByClientSurveyIdDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSurveyAnswersByClientSurveyIdDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientSurveyId': json['clientSurveyId'],
        'clientName': json['clientName'],
        'surveyNamePl': json['surveyNamePl'],
        'surveyNameEn': json['surveyNameEn'],
        'questionsWithAnswers': ((json['questionsWithAnswers'] as Array<any>).map(GetQuestionAndAnswerDtoFromJSON)),
    };
}

export function GetSurveyAnswersByClientSurveyIdDtoToJSON(value?: GetSurveyAnswersByClientSurveyIdDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'clientSurveyId': value.clientSurveyId,
        'clientName': value.clientName,
        'surveyNamePl': value.surveyNamePl,
        'surveyNameEn': value.surveyNameEn,
        'questionsWithAnswers': ((value.questionsWithAnswers as Array<any>).map(GetQuestionAndAnswerDtoToJSON)),
    };
}

